<template>
  <Contact />
</template>

<script setup>
import Contact from '@/sections/contact/Contact.vue';
</script>
